<template>
<div>
  <div class="overlay"></div>
  <nav class="navbar navbar-expand-lg navbar-light justify-content-between" id="navbartop">
    <div class="container-fluid">
      
      <button type="button" id="sidebarCollapse" class="btn btn-outline-light">
        <i class="navbar-toggler-icon"></i>
      </button>
      <div id="logo-navbar"></div>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="nav navbar-nav ml-auto">
          <li class="nav-item active">
            <a class="navbar-brand" href="user-profile" >You are Login as : {{fullName}}</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
  
<!-- <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <div id="logo-navbar"></div>
  <a class="navbar-brand" href="#">Sample Request</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <button type="button" id="sidebarCollapse" class="btn btn-info">
    <i class="fas fa-align-left"></i>
    <span>Toggle Sidebar</span>
  </button>
  <button class="btn btn-dark d-inline-block d-lg-none ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <i class="fas fa-align-justify"></i>
  </button>
  

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li v-for="(nav, navIndex) in navData" :key="navIndex">
        <a v-if="nav.child.length !== 0" class="nav-link dropdown-toggle" href="#" :id="nav.title" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{ nav.title }}
          <div v-if="nav.child.length > 0" class="dropdown-menu" :aria-labelledby="nav.title">
              <router-link v-for="(child, index) in nav.child" :key="index" :to="{ name: child.url }" class="dropdown-item" ><i :class="child.icon"></i> {{ child.title }}</router-link>
          </div>
        </a>
        <router-link v-if="nav.child.length === 0" class="nav-link" :to="{ name: nav.url }">{{ nav.title }}</router-link>
      </li>
      <li>
        <router-link to="" class="nav-link" @click.native="logout">Logout</router-link>
      </li>
    </ul>
  </div>
  <a class="navbar-brand" href="user-profile" >You are Login as : {{fullName}}</a>
</nav> -->
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      fullName: localStorage.getItem('ucf_loggedUser'),
      navData: [
        {
          isNav: true,
          title: 'Dashboard',
          url: 'dashboard',
          icon: 'fas fa-chart-line',
          child: []
        },
        {
          isHeader: true,
          title: 'Transaction',
          child: [
            {
              isNav: true,
              title: 'Request Sample',
              url: 'requestSample',
              icon: 'fas fa-file-signature'
            },
            {
              isNav: true,
              title: 'Approved Quality',
              url: 'approvedQuality',
              icon: 'fas fa-file-invoice'
            },
            {
              isNav: true,
              title: 'Sample Journey',
              url: 'sampleJourney',
              icon: 'fas fa-copy'
            },
          ]
        },
        {
          isHeader: true,
          title: 'Report',
          child: [
            {
              isNav: true,
              title: 'Report Request Sample',
              url: 'rptRequestSample',
              icon: 'fas fa-chart-pie'
            },
          ]
        },
        {
          isHeader: true,
          title: 'Utility',
          child: [
            {
              isNav: true,
              title: 'Mail Management',
              url: 'mailManagement',
              icon: 'fas fa-envelope-open-text'
            },
            {
              isNav: true,
              title: 'Member Management',
              url: 'memberManagement',
              icon: 'fas fa-users-cog'
            },
            {
              isNav: true,
              title: 'User Profile',
              url: 'userProfile',
              icon: 'far fa-id-card'
            },
          ]
        }, 
      ]
    }
  },
  methods: {
    ...mapActions(['appLogout']),
    renderActiveLink(routeName) {
      return (this.$route.name === routeName) ? 'active' : ''
    },
    logout() {
      this.appLogout()
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>
#navbartop {
  background-color: #8aabff;
}
</style>